import React from 'react';
import { CheckCircle, Sparkles, Download, FileText } from 'lucide-react';

const AuditReadyCelebration = ({ onGenerateReport, onExportPackage }) => {
  return (
    <div className="bg-gradient-to-r from-green-50 to-teal-50 border-2 border-green-300 rounded-lg p-8 mt-6 text-center">
      <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
        <CheckCircle className="w-12 h-12 text-green-600" />
      </div>

      <h2 className="text-2xl font-bold text-green-900 mb-2 flex items-center justify-center gap-2">
        Ready for Audit!
        <Sparkles className="w-6 h-6 text-green-600" />
      </h2>

      <p className="text-green-700 mb-6 max-w-2xl mx-auto">
        Congratulations! All compliance controls have been verified. Your organization is ready for the audit process.
        You can now generate audit reports and documentation.
      </p>

      <div className="flex items-center justify-center gap-4">
        <button
          onClick={onGenerateReport}
          className="inline-flex items-center gap-2 px-6 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors font-semibold"
        >
          <FileText className="w-5 h-5" />
          Generate Audit Report
        </button>

        <button
          onClick={onExportPackage}
          className="inline-flex items-center gap-2 px-6 py-3 bg-white text-green-700 border-2 border-green-300 rounded-lg hover:bg-green-50 transition-colors font-semibold"
        >
          <Download className="w-5 h-5" />
          Export Evidence Package
        </button>
      </div>

      <div className="mt-6 p-4 bg-white rounded-lg border border-green-200 max-w-xl mx-auto">
        <h4 className="text-sm font-semibold text-gray-900 mb-2">Next Steps:</h4>
        <ul className="text-sm text-gray-700 space-y-1 text-left">
          <li className="flex items-start gap-2">
            <CheckCircle className="w-4 h-4 text-green-600 mt-0.5 flex-shrink-0" />
            <span>Review all evidence and documentation</span>
          </li>
          <li className="flex items-start gap-2">
            <CheckCircle className="w-4 h-4 text-green-600 mt-0.5 flex-shrink-0" />
            <span>Schedule your audit with a certified auditor</span>
          </li>
          <li className="flex items-start gap-2">
            <CheckCircle className="w-4 h-4 text-green-600 mt-0.5 flex-shrink-0" />
            <span>Maintain continuous compliance monitoring</span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default AuditReadyCelebration;
